module.exports = __webpack_public_path__ + "c0c1fb0c612582b9a7b4f5b0b2f8aa06.jpg";